export const useTopBanner = () => {
    const $topBanner = document.querySelector(".js-ns-top-banner");

    const init = () => {
        const currentScrollPosition = window.scrollY;

        if (currentScrollPosition > 0) {
            $topBanner.classList.add("active");

            return;
        }

        $topBanner.classList.remove("active");
    };

    const initTopBanner = () => {
        if (!$topBanner) {
            return;
        }

        document.addEventListener("DOMContentLoaded", init);
        window.addEventListener("scroll", init);
    };

    return {
        initTopBanner,
    };
};
